<template>
    <v-dialog v-if="showPopup" v-model="showPopup" persistent :width="600">

        <div class="common-popup-container">
            <button class="circle" @click="showPopup = false">
                <img :src="require('@/assets/icons/close.svg')" alt="">
            </button>
            <div class="popup-container">
                <Svg class="narrative-icon" :src="require('@/assets/icons/narrative-eye.svg')"></Svg>
                <h3 class="popup-heading">Narratives</h3>
                <div class="popup-subtitle">
                    <p >
                    See how your ideas, vision, and context can be shaped into a strong narrative that speaks for your
                    business.
                </p>
                </div>

            </div>
            <div class="popup-footer">
                <button class="add-new-btn" @click="nextStep()">
                    <span>Start Tutorial</span>
                </button>
            </div>
        </div>

    </v-dialog>


</template>


<script>
import CloseIcon from '@/assets/icons/close.svg';
export default {
    name: 'Educational Popup',
    props: {
        modelValue: {
            type: Boolean
        },
    },

    data() {
        return {
            CloseIcon,
            showTutorialPopup: false,

        }
    },
    computed: {
        showPopup: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
    },
    methods: {
        nextStep() {
            this.$emit('tutorial-popup', true)
            this.showPopup = false;

        }
    }

}

</script>


<style scoped>
.common-popup-container {
    display: flex;
    flex-direction: column;
    align-items: end;
    background-image: url('@/assets/icons/tutorial-bg.svg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 12px;
    padding: 1em;
    gap: 20px;
    font-family: 'Inter', sans-serif;
}

.popup-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap:8px;
    width: 100%;
}

.popup-heading {
    font-weight: 600;
    font-size: var(--header-font-size);
}

.popup-subtitle {
    font-size: var(--normal-font-size);
    font-style: italic;
    color: var(--light-grey-color);
    text-align: center;
    width: 75%;
   
}

.popup-footer {
    display: flex;
    gap: 1em;
    padding: 16px;
    width: 100%;
}

.add-new-btn {
    width: 100%;
    padding: 12px;
    background: var(--primary-gradient);
    border-radius: 8px;
    font-weight: 500;
    color: var(--secondary-font-color);
}
</style>